import { styled } from "styled-components";

export const CategoryListContainer = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0;
  margin: 0;
  width: 200px;
  background-color: transparent;
  align-items: center;
  background-color: #f5f6f8;
`;
